{
	"ariaCancelAIHealing": "Cancel AI Healing",
	"ariaRunInBackground": "Run AI Healing In Background",
	"runInBackground": "Run in background",
	"titleAiErase": "Removing area using AI...",
	"titleAiGenerate": "Generating with AI...",
	"tipEraseLargerMask": "Tip: Paint your mask slightly larger than the object you want to remove.",
	"tipEraseUseGenerate": "Tip: Unexpected results? Switch to AI Generate and describe exactly what to keep or remove.",
	"tipEraseFeather": "Tip: If there are minor artifacts along the mask edge, try increasing the Feather slider.",
	"tipGenerateBeSpecific": "Tip: Be specific in your prompt — describe what to add, change, or remove for best results.",
	"tipGenerateExpandMask": "Tip: If the generated content is cut off at the edges, toggle on Expand Mask Area.",
	"tipGenerateReference": "Tip: You can upload up to 2 reference images to guide the generation.",
	"tipGenerateFeather": "Tip: If there are minor artifacts along the mask edge, try increasing the Feather slider."
}
